import environment from "environment";
import IAction from "models/IAction";
import ResponseAuthTokensModel from "stores/shared/models/ResponseAuthTokensModel";
import ResponseEsitoModel from "stores/shared/models/ResponseEsitoModel";
import BaseReducer from "utilities/BaseReducer";
import ExternalInfoModel from "./models/ExternalInfoModel";
import IUtenteState from "./models/IUtenteState";
import ProfiloUtenteModel from "./models/ProfiloUtenteModel";
import UtenteModel from "./models/UtenteModel";
import UtenteAction from "./UtenteAction";
import UserInfoModel from "./models/UserInfoModel";
import UserPermissionModel from "./models/UserPermissionModel";

export default class UtenteReducer extends BaseReducer<IUtenteState> {
    public readonly initialState: IUtenteState = {
        profilo: new ProfiloUtenteModel({}),
        responseRegistrazione: false,
        responseVerificaToken: false,
        responseConfermaRegistrazione: false,
        responseRecuperoPassword: false,
        responseTokenRecuperoPassword: false,
        responseCambioPassword: false,
        authenticated: false,
        externalInfo: new ExternalInfoModel({}),
        responsePermissions: new UserPermissionModel({}),
    };

    public [UtenteAction.REQUEST_COOKIE_CONSENT_SET_FINISHED](
        state: IUtenteState,
        action: IAction<boolean>
    ): IUtenteState {
        return {
            ...state,
            profilo: {
                ...state.profilo,
                isCookieAllowed: action.payload!,
            } as ProfiloUtenteModel,
        };
    }

    public [UtenteAction.REQUEST_MENU_SIZE_SET_FINISHED](state: IUtenteState, action: IAction<boolean>): IUtenteState {
        return {
            ...state,
            profilo: {
                ...state.profilo,
                isMenuFullSize: action.payload!,
            } as ProfiloUtenteModel,
        };
    }

    public [UtenteAction.REQUEST_UTENTE_LOGIN_GET_FINISHED](
        state: IUtenteState,
        action: IAction<ResponseAuthTokensModel>
    ): IUtenteState {
        let accessToken: string = "";
        let refreshToken: string = "";
        let isLogged = false;
        if (action.payload && action.payload!.accessToken && action.payload!.refreshToken) {
            accessToken = action.payload!.accessToken;
            refreshToken = action.payload!.refreshToken;
            isLogged = true;
        }
        sessionStorage.setItem(environment.accessTokenName, accessToken);
        sessionStorage.setItem(environment.refreshTokenName, refreshToken);
        return {
            ...state,
            authenticated: true,
            profilo: {
                ...state.profilo,
                isLogged: isLogged,
            } as ProfiloUtenteModel,
        };
    }

    public [UtenteAction.REQUEST_UTENTE_LOGIN_REQUIRED_SET_FINISHED](
        state: IUtenteState,
        action: IAction<boolean>
    ): IUtenteState {
        const accessToken = sessionStorage.getItem(environment.accessTokenName);
        const refreshToken = sessionStorage.getItem(environment.refreshTokenName);
        let isLogged = false;
        if (accessToken && refreshToken) {
            isLogged = true;
        }
        return {
            ...state,
            authenticated: isLogged,
            profilo: {
                ...state.profilo,
                isLogged: isLogged,
                isLoginRequired: action.payload!,
            } as ProfiloUtenteModel,
        };
    }

    public [UtenteAction.REQUEST_UTENTE_LOGOUT_GET_FINISHED](
        state: IUtenteState,
        action: IAction<ResponseEsitoModel>
    ): IUtenteState {
        sessionStorage.removeItem(environment.accessTokenName);
        sessionStorage.removeItem(environment.refreshTokenName);
        sessionStorage.removeItem(environment.descUoName);
        sessionStorage.removeItem(environment.codAgency);
        return {
            ...state,
            profilo: new ProfiloUtenteModel({
                username: "",
                isLogged: false,
            }),
        };
    }

    public [UtenteAction.REQUEST_UTENTE_GET_FINISHED](state: IUtenteState, action: IAction<UtenteModel>): IUtenteState {
        return {
            ...state,
            profilo: {
                ...state.profilo,
                nome: action.payload!.nome,
                cognome: action.payload!.cognome,
                email: action.payload!.email,
                nomeAzienda: action.payload!.nomeAzienda,
            } as ProfiloUtenteModel,
        };
    }

    public [UtenteAction.REQUEST_USERINFO_GET_FINISHED](
        state: IUtenteState,
        action: IAction<UserInfoModel>
    ): IUtenteState {
        let descUo = action.payload && action.payload.descrizioneUO ? action.payload!.descrizioneUO : "";
        let codUo = action.payload && action.payload.descrizioneUO ? action.payload!.cdc : "";
        let codAgency = action.payload && action.payload.codiceAgenzia ? action.payload!.codiceAgenzia : "";
        sessionStorage.setItem(environment.descUoName, descUo + "(" + codUo + ")");
        sessionStorage.setItem(environment.codAgency, codAgency);
        return {
            ...state,
            profilo: {
                ...state.profilo,
                cdc: action.payload!.cdc,
                tipoCdc: action.payload!.tipoCdc,
                descUO: action.payload!.descrizioneUO,
                //codAgency: action.payload!.codiceAgenzia,
            } as ProfiloUtenteModel,
        };
    }

    public [UtenteAction.REQUEST_UTENTE_RECUPERO_PASSWORD_SET_FINISHED](
        state: IUtenteState,
        action: IAction<ResponseEsitoModel>
    ): IUtenteState {
        return {
            ...state,
            responseRecuperoPassword: action.payload!.esito,
        };
    }

    public [UtenteAction.REQUEST_VERIFICA_TOKEN_RECUPERO_PASSWORD_GET_FINISHED](
        state: IUtenteState,
        action: IAction<ResponseEsitoModel>
    ): IUtenteState {
        return {
            ...state,
            responseTokenRecuperoPassword: action.payload!.esito,
        };
    }

    public [UtenteAction.REQUEST_UTENTE_CAMBIO_PASSWORD_SET_FINISHED](
        state: IUtenteState,
        action: IAction<ResponseEsitoModel>
    ): IUtenteState {
        return {
            ...state,
            responseCambioPassword: action.payload!.esito,
        };
    }

    public [UtenteAction.REQUEST_AUTHENTICATE_EXTERNAL_FINISHED](
        state: IUtenteState,
        action: IAction<ResponseAuthTokensModel>
    ): IUtenteState {
        let accessToken: string = "";
        let refreshToken: string = "";
        let isLogged = false;
        if (action.payload && action.payload!.accessToken && action.payload!.refreshToken) {
            accessToken = action.payload!.accessToken;
            refreshToken = action.payload!.refreshToken;
            isLogged = true;
        }
        sessionStorage.setItem(environment.accessTokenName, accessToken);
        sessionStorage.setItem(environment.refreshTokenName, refreshToken);
        return {
            ...state,
            authenticated: true,
            profilo: {
                ...state.profilo,
                isLogged: isLogged,
            } as ProfiloUtenteModel,
        };
    }

    public [UtenteAction.AUTHENTICATE_SET_EXTERNAL_INFO](
        state: IUtenteState,
        action: IAction<ExternalInfoModel>
    ): IUtenteState {
        sessionStorage.setItem("member", action.payload?.member?.toString() || "");
        sessionStorage.setItem("abi", action.payload?.abi?.toString() || "");
        return {
            ...state,
            externalInfo: action.payload!,
        };
    }

    public [UtenteAction.AUTHENTICATE_RESET](state: IUtenteState, action: IAction<any>): IUtenteState {
        sessionStorage.removeItem(environment.accessTokenName);
        sessionStorage.removeItem(environment.refreshTokenName);
        sessionStorage.removeItem("member");
        sessionStorage.removeItem("abi");
        sessionStorage.removeItem(environment.descUoName);
        sessionStorage.removeItem(environment.codAgency);
        return {
            ...this.initialState,
        };
    }

    public [UtenteAction.SET_USER_AUTHENTICATED](state: IUtenteState, action: IAction<void>): IUtenteState {
        return {
            ...state,
            authenticated: true,
            profilo: {
                ...state.profilo,
                isLogged: true,
                descUO: state.profilo.descUO,
                //codAgency: state.profilo.codAgency,
            } as ProfiloUtenteModel,
        };
    }

    public [UtenteAction.REQUEST_USER_PERMISSIONS_GET_FINISHED](
        state: IUtenteState,
        action: IAction<UserPermissionModel>
    ): IUtenteState {
        return {
            ...state,
            responsePermissions: {
                ...state.responsePermissions,
                permissions: action.payload!.permissions,
            } as UserPermissionModel,
        };
    }
}
